// Product intake helpers. Fiscal rules must be vetted against current official sources;
// these are candidates for human review, never automatic tax determination.
export const FISCAL_SOURCES={
  ncm:'https://www.gov.br/receitafederal/pt-br/acesso-a-informacao/legislacao/tipi-tabela-de-incidencia-do-imposto-sobre-produtos-industrializados',
  cest:'https://www.confaz.fazenda.gov.br/legislacao/convenios/2018/CV142_18'
};

export function suggestSku(form,existing=[],excludeId=''){
  const provided=String(form?.sku||'').trim().toUpperCase();
  if(provided)return provided;
  const used=new Set(existing.filter(p=>p.id!==excludeId).map(p=>String(p.sku||'').toUpperCase()));
  const barcode=String(form?.barcode||'').replace(/[^A-Za-z0-9]/g,'');
  const base=barcode ? 'EAN-'+barcode.slice(0,30) :
    'PROD-'+String(form?.name||'ITEM').normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .toUpperCase().replace(/[^A-Z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,28);
  const normalized=base==='PROD-'?'PROD-ITEM':base;
  if(!used.has(normalized))return normalized;
  for(let i=2;i<=9999;i++){
    const next=normalized+'-'+String(i).padStart(3,'0');
    if(!used.has(next))return next;
  }
  return '';
}

export function productSaveIssues(form,products=[]){
  const errors=[];
  if(String(form?.name||'').trim().length<2)errors.push('Informe o nome do produto (mínimo de 2 caracteres).');
  const sku=suggestSku(form,products,form?.id);
  if(sku.length<2)errors.push('Não foi possível gerar um SKU único.');
  if(products.some(p=>p.id!==form?.id&&String(p.sku||'').toUpperCase()===sku))errors.push('SKU já cadastrado neste estabelecimento.');
  const barcode=String(form?.barcode||'').trim();
  if(barcode&&products.some(p=>p.id!==form?.id&&p.barcode===barcode))errors.push('Código de barras já cadastrado neste estabelecimento.');
  if(barcode&&/^\d+$/.test(barcode)&&[8,12,13,14].includes(barcode.length)){
    // A GTIN failing its check digit may not be persisted as valid GTIN.
    // Crosschecked separately in the screen via isValidGtin.
  }
  return errors;
}
export function fiscalCandidate(form){
  const raw=[form?.name,form?.description,form?.metadata?.commerce?.online_title,
    form?.metadata?.commerce?.package_size].filter(Boolean).join(' ').normalize('NFD')
    .replace(/[\u0300-\u036f]/g,'').toLowerCase();
  if(!/agua\s+mineral/.test(raw)||/(aromatizad|adocad|acucar|saborizad)/.test(raw))return null;
  // This curated CEST candidate only covers the 1.5 L bottle case, not all mineral water.
  if(!/(?:1[.,]5\s*(?:l|litro)|1500\s*ml)/.test(raw))return null;
  return {
    ncm:'22011000',cest:'0300600',
    ncm_label:'Águas minerais e águas gaseificadas',
    cest_label:'Outras águas minerais/potáveis naturais — verificar embalagem e exceções',
    requires_confirmation:'Confirme que se trata de água mineral natural sem adição de aromas/açúcar, acondicionada em garrafa plástica e não incluída em exceções.',
    sources:[FISCAL_SOURCES.ncm,FISCAL_SOURCES.cest],
    as_of:'2026-10-09',status:'unverified_candidate',
    deprecated_warning:'Não use o CEST 03.004.00: revogado desde 2021.'
  };
}


/** Opening stock belongs to the ledger; it is NOT the minimum stock threshold. */
export function openingStockIssue(value,allowFractional=false,canAdjust=true){
  const original=String(value??'').trim();
  if(!original)return '';
  if(!/^(?:\d+)(?:[.,]\d{1,3})?$/.test(original))return 'Informe uma quantidade válida com até três casas decimais.';
  const n=Number(original.replace(',','.'));
  if(!Number.isFinite(n)||n<0||n>1000000)return 'Quantidade inicial deve estar entre 0 e 1.000.000.';
  if(!allowFractional&&!Number.isInteger(n))return 'Este produto não permite quantidade fracionada.';
  if(n>0&&!canAdjust)return 'Seu usuário não possui permissão para lançar estoque inicial.';
  return '';
}
